var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list-item-subtitle',{class:_vm.cssClass,staticStyle:{"margin-bottom":"2px"}},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.data || "-"))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }